var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.9566V3.38672",
    stroke: "#8A8E96",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7207 20.5004H3.21664C3.21664 20.5004 1.92711 20.4784 1.36961 19.9421C1.16323 19.742 1 19.2634 1 19.0039",
    stroke: "#8A8E96",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9924 1H2.66932C1.75111 1 1 1.72745 1 2.61595V3.03779C1 3.92634 1.75115 4.65375 2.66932 4.65375H16.7207V8",
    stroke: "#8A8E96",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2097 1C15.2097 1 13.5445 2.94114 15.991 4.65379",
    stroke: "#8A8E96",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5015 14.3312C20.5015 16.7233 18.5513 18.6624 16.1453 18.6624C13.7394 18.6624 11.7891 16.7233 11.7891 14.3312C11.7891 11.9392 13.7394 10 16.1453 10C18.5513 10 20.5015 11.9392 20.5015 14.3312Z",
    stroke: "#8A8E96",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7639 14.0602L15.7822 15.178L17.6454 13.2977",
    stroke: "#8A8E96",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsIcon);
export default __webpack_public_path__ + "static/media/claims-icon.060e4e15c4fff8a373fe300c7a925733.svg";
export { ForwardRef as ReactComponent };